import { render, staticRenderFns } from "./InregistrareCont.vue?vue&type=template&id=06004624"
import script from "./InregistrareCont.vue?vue&type=script&lang=js"
export * from "./InregistrareCont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports